import { Container } from '@bpba/ui-components';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { Buscador } from './pages/Buscador';
import { TIPO_PACTAR, TIPO_PROCAMPO_ARS, TIPO_PROCAMPO_USD } from './Constantes';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AnalyticsRoot />
      <Container minHeight={500}>
        <Routes>
          <Route path="*" element={<Navigate to="/buscador/pactar" />} />
          <Route path="/buscador/pactar" element={<Buscador tipo={TIPO_PACTAR} />}></Route>
          <Route path="/buscador/procampoars" element={<Buscador tipo={TIPO_PROCAMPO_ARS} />}></Route>
          <Route path="/buscador/procampousd" element={<Buscador tipo={TIPO_PROCAMPO_USD} />}></Route>
        </Routes>
      </Container>
    </BrowserRouter>
  );
}
export default App;
